import React from 'react';
import './cookies.css';

function Cookies() {
  return (
    <div className="cookies-container">
      <div className="cookies-header">
        <h1>Chính sách Cookie</h1>
        <p className="cookies-updated">Cập nhật lần cuối: 01/10/2025</p>
      </div>

      <div className="cookies-content">
        <section className="cookies-section">
          <h2>1. Cookie là gì?</h2>
          <p>
            Cookie là những tệp văn bản nhỏ được lưu trữ trên thiết bị của bạn khi truy cập website. 
            Chúng giúp website ghi nhớ thông tin về truy cập và tùy chọn của bạn, giúp cải thiện 
            trải nghiệm người dùng.
          </p>
        </section>

        <section className="cookies-section">
          <h2>2. Các loại cookie chúng tôi sử dụng</h2>
          
          <h3>2.1. Cookie thiết yếu</h3>
          <ul>
            <li>Duy trì phiên đăng nhập của bạn</li>
            <li>Bảo mật và xác thực người dùng</li>
            <li>Ghi nhớ nội dung giỏ hàng</li>
            <li>Xử lý các chức năng cơ bản của website</li>
          </ul>

          <h3>2.2. Cookie phân tích</h3>
          <ul>
            <li>Theo dõi lượt truy cập và hành vi người dùng</li>
            <li>Đánh giá hiệu quả của các tính năng</li>
            <li>Thu thập dữ liệu về thiết bị và trình duyệt</li>
            <li>Tối ưu hóa hiệu suất website</li>
          </ul>

          <h3>2.3. Cookie chức năng</h3>
          <ul>
            <li>Ghi nhớ tùy chọn ngôn ngữ</li>
            <li>Lưu cài đặt giao diện</li>
            <li>Cá nhân hóa trải nghiệm người dùng</li>
          </ul>
        </section>

        <section className="cookies-section">
          <h2>3. Quản lý cookie</h2>
          <p>
            Bạn có thể kiểm soát và quản lý cookie trong trình duyệt của mình:
          </p>
          <ul>
            <li>Xem các cookie đã được lưu trữ</li>
            <li>Xóa một hoặc tất cả cookie</li>
            <li>Chặn cookie từ các website cụ thể</li>
            <li>Cấu hình cài đặt cookie cho từng website</li>
          </ul>
          <p>
            Lưu ý rằng việc vô hiệu hóa cookie có thể ảnh hưởng đến trải nghiệm 
            và một số tính năng của website.
          </p>
        </section>

        <section className="cookies-section">
          <h2>4. Cookie của bên thứ ba</h2>
          <p>
            Chúng tôi sử dụng một số dịch vụ của bên thứ ba có thể đặt cookie:
          </p>
          <ul>
            <li>Google Analytics - phân tích người dùng</li>
            <li>Cloudflare - bảo mật và hiệu suất</li>
            <li>Các nền tảng thanh toán trực tuyến</li>
          </ul>
        </section>

        <section className="cookies-section">
          <h2>5. Thời gian lưu trữ cookie</h2>
          <ul>
            <li>Cookie phiên: tự động xóa khi đóng trình duyệt</li>
            <li>Cookie liên tục: lưu trữ trong thời gian xác định</li>
            <li>Cookie vĩnh viễn: lưu trữ cho đến khi bị xóa thủ công</li>
          </ul>
        </section>

        <section className="cookies-section">
          <h2>6. Cập nhật chính sách</h2>
          <p>
            Chúng tôi có thể cập nhật chính sách cookie này để phản ánh những thay đổi 
            về cách sử dụng cookie trên website. Mọi thay đổi sẽ được thông báo trên 
            trang này.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Cookies; 